<template>
  <transition name="fade">
    <div v-if="show">
      <portal-simple-alert
        v-if="type === 'alert'"
        :text="text"
        :title="title"
        :variant="variant"
        @dismiss="dismiss()"
      />
      <portal-confirmation-alert
        v-if="type === 'confirmation'"
        :text="text"
        :title="title"
        :ok="ok"
        :cancel="cancel"
        @dismiss="dismiss()"
        @confirm="confirm()"
      />
    </div>
  </transition>
</template>
<script>
import PortalSimpleAlert from "./PortalSimpleAlert.vue"
import PortalConfirmationAlert from "./PortalConfirmationAlert.vue"
import { portalEvents } from "./PortalEvents"
import ConfirmationAlert from "../../js/plugins/Alert/ConfirmationAlert.vue"

export default {
  name: "PortalAlerts",
  components: { ConfirmationAlert, PortalSimpleAlert, PortalConfirmationAlert },
  data() {
    return {
      show: false,
      type: "alert",
      variant: "error",
      title: null,
      text: "",
      ok: "Confirm",
      cancel: "Cancel",
      onDismiss: () => {},
      onConfirm: () => {},
    }
  },
  mounted() {
    portalEvents.on("show", (options) => {
      this.type = options.type || "alert"
      this.variant = options.variant || "error"
      this.text = options.text || "Alert"
      this.title = options.title || null
      this.ok = options.ok || "Confirm"
      this.cancel = options.cancel || "Cancel"
      this.onConfirm = options.onConfirm || (() => {})
      this.onDismiss = options.onDismiss || (() => {})
      this.show = true
    })
  },
  methods: {
    close() {
      this.show = false
    },

    confirm() {
      this.onConfirm()
      this.show = false
    },

    dismiss() {
      this.onDismiss()
      this.show = false
    },
  },
}
</script>
